import React from 'react';
import {Spinner} from 'react-bootstrap';
import ConditionalRender from "../ConditionalRender";

const LoadingSpinner = ({text = null, variant='primary', animation='border', className = undefined, small = false, show= true}) => {
  return (
      <ConditionalRender condition={show}>
        <div className={`${className ? className : ''} d-flex flex-column align-items-center`}>
            <Spinner size={small ? "sm" : null} animation={animation} variant={variant}/>
            {text && !small && <span className='mt-1'>{text}</span>}
            {text && small && <small className='mt-1'>{text}</small>}
        </div>
      </ConditionalRender>
  );
};

export default LoadingSpinner;